import { getEnvs } from '@/helpers/getEnvs'

export const checkIsAppEnvironment = (): boolean => {
  const currentEnv = getEnvs()?.APP_ENVIRONMENT
  if (!currentEnv) return false
  const APP_ENVIRONMENT_NAMES = ['light']
  return APP_ENVIRONMENT_NAMES.includes(currentEnv)
}

export const checkIsProduction = (): boolean => {
  const isProduction = getEnvs()?.IS_PRODUCTION
  return isProduction === 'true'
}

export const checkIsWhiteLabel = (): boolean => {
  const currentEnv = getEnvs()?.APP_ENVIRONMENT
  return currentEnv === 'violet'
}
